import Cookies from 'js-cookie';
import { useState } from 'react';
import useAuth from '../../hook/useAuth';
import useConfirm from '../../hook/useConfirm';
import axios from 'axios';
import { ticketBaseURL } from '../../config/api';
import Cross from '../../icons/Cross';
import { post_MyCdirAchInfo } from '../../services/ACHInfo';

type ACHProps = {
    showPopupAddNewACH: boolean;
    setShowPopupAddNewACH: (value: boolean) => void;
    setIsRefresh: (value: boolean) => void;
}

const AddACH = ({ showPopupAddNewACH, setShowPopupAddNewACH, setIsRefresh }: ACHProps) => {
    const tenantId = Cookies.get("tenantId-my-cdir") || "";
    const { auth }: any = useAuth();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const userId = Cookies.get("userId-my-cdir");

    const [achDetails, setACHDetails] = useState<any>({
        accountNumber: "",
        accountType: "",
        routingNumber: "",
        bankName: "",
        bankPhone: "",
        accountHolderName: "",
        useAccountInfoInFuture: false,
        signedAcknowledgement: false
    });

    const [isProcessing, setIsProcessing] = useState<boolean>(false);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (isProcessing) return;

        setIsProcessing(true);

        try {
            const response = await axios.get(
                `${ticketBaseURL}rdRentalACHInfo/DoesRdRentalACHInfoExist`,
                {
                    params: {
                        accountNumber: achDetails?.accountNumber,
                        routingNumber: achDetails?.routingNumber,
                        tenantId: tenantId
                    }
                }
            );

            const cardExists = response.data === true;

            if (cardExists) {
                setConfirmData({
                    title: 'Warning',
                    summary: "This ACH is already added for this group.",
                    confirmBtn: 'Ok',
                    isConfirm: (callback: any) => {
                        callback();
                    }
                });

                setConfirmPopup(true);

                setIsProcessing(false);
                return;
            }

            await post_MyCdirAchInfo({
                ...achDetails,
                isActive: true,
                userId: Number(userId),
                tenantId: tenantId
            }, auth?.id);

            setIsRefresh(true);
            setShowPopupAddNewACH(false);
            setACHDetails({
                accountNumber: "",
                accountType: "",
                routingNumber: "",
                bankName: "",
                bankPhone: "",
                accountHolderName: "",
                useAccountInfoInFuture: false,
                signedAcknowledgement: false
            });
        } catch (error) {
            console.error(error);
        } finally {
            setIsProcessing(false);
        }
    };

    const closeModal = () => setShowPopupAddNewACH(false);

    return (
        <div className={`fixed inset-0 p-4 mt-20 ${showPopupAddNewACH ? 'flex' : 'hidden'} flex-wrap justify-center items-center w-full h-fit z-50 overflow-auto`}>

            <div className="relative w-full max-w-[32rem] rounded-2xl bg-secondary p-6 shadow-2xl">

                <button
                    type="button"
                    onClick={closeModal}
                    className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-full transition hover:bg-white/10"
                >
                    <Cross className={`h-3 w-3 text-secondary`} />
                </button>

                <h3 className={`mb-6 text-lg font-semibold text-secondary`}>
                    Add ACH Details
                </h3>

                <form
                    className="flex flex-col gap-4"
                    onSubmit={handleSubmit}
                >

                    <div className="flex flex-col">
                        <label className={`mb-1 text-xs font-medium text-secondary`}>
                            Account Holder Name
                        </label>

                        <input
                            type="text"
                            className={`w-full rounded-md border px-3 py-2 text-sm outline-none focus:border-[#167AC3] border-secondary bg-transparent`}
                            value={achDetails.accountHolderName}
                            onChange={(e) =>
                                setACHDetails({
                                    ...achDetails,
                                    accountHolderName: e.target.value
                                })
                            }
                            required
                        />
                    </div>

                    <div className="flex flex-col">
                        <label className={`mb-1 text-xs font-medium text-secondary`}>
                            Account Number
                        </label>

                        <input
                            type="text"
                            className={`w-full rounded-md border px-3 py-2 text-sm outline-none focus:border-[#167AC3] border-secondary bg-transparent`}
                            value={achDetails.accountNumber}
                            onChange={(e) =>
                                setACHDetails({
                                    ...achDetails,
                                    accountNumber: e.target.value
                                })
                            }
                            required
                        />
                    </div>

                    <div className="flex flex-col">
                        <label className={`mb-1 text-xs font-medium`}>
                            Routing Number
                        </label>

                        <input
                            type="text"
                            className={`w-full rounded-md border px-3 py-2 text-sm outline-none focus:border-[#167AC3] border-secondary bg-transparent`}
                            value={achDetails.routingNumber}
                            onChange={(e) =>
                                setACHDetails({
                                    ...achDetails,
                                    routingNumber: e.target.value
                                })
                            }
                            required
                        />
                    </div>

                    <div className="flex flex-col">
                        <label className={`mb-1 text-xs font-medium`}>
                            Bank Name
                        </label>

                        <input
                            type="text"
                            className={`w-full rounded-md border px-3 py-2 text-sm outline-none focus:border-[#167AC3] border-secondary bg-transparent`}
                            value={achDetails.bankName}
                            onChange={(e) =>
                                setACHDetails({
                                    ...achDetails,
                                    bankName: e.target.value
                                })
                            }
                        />
                    </div>

                    <div className="flex flex-col">
                        <label className={`mb-1 text-xs font-medium`}>
                            Bank Phone
                        </label>

                        <input
                            type="text"
                            className={`w-full rounded-md border px-3 py-2 text-sm outline-none focus:border-[#167AC3] border-secondary bg-transparent`}
                            value={achDetails.bankPhone}
                            onChange={(e) =>
                                setACHDetails({
                                    ...achDetails,
                                    bankPhone: e.target.value
                                })
                            }
                        />
                    </div>

                    <div className="flex flex-col">
                        <label className={`mb-1 text-xs font-medium`}>
                            Account Type
                        </label>

                        <select
                            className={`w-full rounded-md border px-3 py-2 text-sm outline-none focus:border-[#167AC3] border-secondary bg-transparent`}
                            value={achDetails.accountType}
                            onChange={(e) =>
                                setACHDetails({
                                    ...achDetails,
                                    accountType: e.target.value
                                })
                            }
                            required
                        >
                            <option value="">Select</option>
                            <option value="checking">Checking</option>
                            <option value="savings">Savings</option>
                        </select>
                    </div>

                    <div className="flex items-center gap-2">
                        <input
                            type="checkbox"
                            id="useAccountInfoInFuture"
                            checked={achDetails.useAccountInfoInFuture}
                            onChange={(e) =>
                                setACHDetails({
                                    ...achDetails,
                                    useAccountInfoInFuture: e.target.checked
                                })
                            }
                        />

                        <label
                            htmlFor="useAccountInfoInFuture"
                            className={`text-xs text-secondary`}
                        >
                            Use account info in future
                        </label>
                    </div>

                    <div className="flex items-center gap-2">
                        <input
                            type="checkbox"
                            id="signedAcknowledgement"
                            checked={achDetails.signedAcknowledgement}
                            onChange={(e) =>
                                setACHDetails({
                                    ...achDetails,
                                    signedAcknowledgement: e.target.checked
                                })
                            }
                            required
                        />

                        <label
                            htmlFor="signedAcknowledgement"
                            className={`text-xs text-secondary`}
                        >
                            I acknowledge and authorize ACH transactions
                        </label>
                    </div>

                    <div className="pt-3">
                        <button
                            type="submit"
                            className="rounded-md bg-[#167AC3] px-5 py-2 text-sm font-medium text-white transition hover:opacity-90"
                        >
                            {isProcessing ? "Processing..." : "Save"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default AddACH;